import { CreateVolunteerRequest, VolunteerResponse } from '@codey2/codey-api-types/models';
import { usePrivateApi } from './usePrivateApi';
import { useCallback, useState } from 'react';
import { codeyApiClient } from './codeyApiClient';

export function useVolunteersApi() {
  const [isLoading, setIsLoading] = useState(false);
  const { doPost, doDelete } = usePrivateApi();

  const getAllVolunteers = useCallback(async (): Promise<VolunteerResponse[]> => {
    try {
      setIsLoading(true);
      return await codeyApiClient.get<VolunteerResponse[]>('/volunteers/public');
    } finally {
      setIsLoading(false);
    }
  }, []);

  const createVolunteer = useCallback(
    async (request: CreateVolunteerRequest): Promise<VolunteerResponse> => {
      try {
        setIsLoading(true);
        return await doPost<CreateVolunteerRequest, VolunteerResponse>('/volunteers', request);
      } finally {
        setIsLoading(false);
      }
    },
    [doPost]
  );

  const deleteVolunteer = useCallback(
    async (volunteerId: number): Promise<void> => {
      try {
        setIsLoading(true);
        await doDelete(`/volunteers/${volunteerId}`);
      } finally {
        setIsLoading(false);
      }
    },
    [doDelete]
  );

  return {
    getAllVolunteers,
    createVolunteer,
    deleteVolunteer,
    isLoading,
  };
}
